import Breakpoint from './modules/breakpoint';
import swatchList from './modules/swatch-list';

const init = () => {
  const map = {};
  map[Breakpoint.XS.name] = 3;
  map[Breakpoint.SM.name] = 5;
  map[Breakpoint.MD.name] = 7;
  map[Breakpoint.LG.name] = 7;
  map[Breakpoint.XL.name] = 10;
  map[Breakpoint.XXL.name] = 10;
  swatchList('.product-swatch-list', map);
};

init();
